export const SN_PERMISSION = 'permission'
export const PERMISSION_BY_CLASSIFICATION_GROUPS_UPDATED = SN_PERMISSION + '/PERMISSIONS_BY_CLASSIFICATION_GROUPS_UPDATED'
export const PERMISSION_QUERY_UPDATED = SN_PERMISSION+ '/QUERY_UPDATED'
export const PERMISSION_CURRENT_GROUP_UPDATED = SN_PERMISSION+ '/CURRENT_GROUP_UPDATED'
export const PERMISSION_PERMISSIONS_BY_GROUP_UPDATED = SN_PERMISSION+ '/PERMISSIONS_BY_GROUP_UPDATED'
export const PERMISSION_ALL_PERMISSIONS_UPDATED = SN_PERMISSION+ '/ALL_PERMISSIONS_UPDATED'
